import * as React from 'react';
import { useState, useEffect } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box, Dialog } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import { loginApi } from "../../services/authApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function ForgetPassword(props) {
  const { disableButton, handleForgetPasswordValues, forgetPasswordValues, handleForgetPasswordStep2Submit, customToastify, handleShowingFormsValues } = props

  const handleClickSubmit = (e) => {
    // if (userPassword.length <7) customToastify("error", "کلمه عبور حداقل باید 8 کاراکتر باشد")
    // if (userPassword.length >255) customToastify("error", "کلمه عبور حداکثر باید 255 کاراکتر باشد")
    // if (userPassword !== confirmUserPassword) customToastify("error", "کلمه عبور و تکرار آن یکی نمی باشد")
    // else 
    handleForgetPasswordStep2Submit()
  }
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" color="darkgoldenrod" variant="body1" >
        لطفا  کد پیامک شده را وارد کنید
      </Typography>

      <Box noValidate sx={{ mt: 1 }}>
        <TextField
          //   margin="normal"
          sx={{ m: 0.3 }}
          required
          fullWidth
          id="confirmCode"
          label="کد دیافتی"
          name="confirmCode"
          value={forgetPasswordValues.confirmCode}
          onChange={(e) => handleForgetPasswordValues("confirmCode", e.target.value)}
          autoComplete="confirmCode"
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ادامه
        </Button>
        <Grid container>
          <Container maxWidth="sx"  >
            <Link href="#" onClick={() => { handleShowingFormsValues("ForgetPassword") }} variant="body2">
              {"ورود با شماره ای دیگر"}
            </Link>
          </Container >
        </Grid>
      </Box>
    </Box>
  )
}